import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "summernote/dist/summernote-lite.css";
import "summernote/dist/summernote-lite.js";

import "./styles/global.css";
import "./index.css"

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);